export enum PersonTypeEnum {
    PF = 'PF',
    PJ = 'PJ'
}
